import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import '@/assets/swiper/swiper.css';
import ExhibitorModalContent from '../ExhibitorModalContent/ExhibitorModalContent.vue';
import NewsModalContent from '../NewsModalContent/NewsModalContent.vue';

export default {
  name: 'ModalContentFactory',
  components: {
    swiper,
    swiperSlide,
    BulmaAccordion,
    BulmaAccordionItem,
    ExhibitorModalContent,
    NewsModalContent,
  },
  props: {
    terminalmode: {
      type: Boolean,
      default: false,
    },
    entry: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    hallplanPath: {
      type: String,
      default: '',
    },
    existingEntries: {
      type: Array,
      default: [],
    },
    categoriesTitle: {
      type: String,
      default: 'Kategorien',
    },
    travelDestinationTitle: {
      type: String,
      default: 'Reiseziele',
    },
  },
  methods: {
    setFavourite(entryId) {
      this.$emit('set-favourite', entryId);
    },
  },
};
